import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  Progress,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  getBanks,
  getCashFlowByTypeToDashboard,
  getKpiCashFlow,
} from "services/dashboard/dashboard-service";
import { notificationErroInternal, notificationInfo } from "util/api-utils";
import { formatCurrency, formatCurrencyWithoutRS } from "util/format";
import FusionCharts from "fusioncharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.gammel";
import ReactFC from "react-fusioncharts";
import ReactFusioncharts from "react-fusioncharts";
import * as Widgets from "fusioncharts/fusioncharts.widgets.js";
import Powercharts from "fusioncharts/fusioncharts.powercharts";

import {
  mountCharBar,
  mountCharBarCategory,
  mountCharBarClient,
  mountCharFunil,
  mountChartLine,
  mountChartMultBar,
  mountChartMultLine,
  mountChartPie,
  mountChartProfitBar,
  mountTreemap,
  mountWaterFall,
  replaceMonth,
} from "./func-chart";
import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  getIncome,
  getIncomeV2,
  getStatus,
} from "services/client/client-service";
import { CSVLink } from "react-csv";
dayjs.extend(customParseFormat);
const dateFormat = "MM/YYYY";
import TreeMap from "fusioncharts/fusioncharts.treemap";
import ExcelExport from "fusioncharts/fusioncharts.excelexport";
import {
  CalendarDays,
  ArrowRight,
  Landmark,
  Maximize,
  CalendarClock,
  FileInput,
  MoveUpRight,
  GitMerge,
} from "lucide-react";
ReactFC.fcRoot(
  FusionCharts,
  Powercharts,
  TreeMap,
  Widgets,
  ExcelExport,
  FusionTheme
);
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  PieChart,
  Pie,
  Cell,
  ComposedChart,
  LabelList,
} from "recharts";

FusionCharts.options["license"] = false;

const { info } = Modal;
const { RangePicker } = DatePicker;
const font = '"Montserrat", sans-serif';
const { Text } = Typography;
const padColor = "#EC6D62";
const receiveColor = "#0071FF";
const profitColor = "#FF9900";
const COLORS = [
  "#0071FF",
  "#EC6D62",
  "#FA8F21",
  "#737373",
  "#22C55E",
  "#1677FF",
  "#EE6A5F",
  "#09AC9C",
  "#12475B",
  "#00887B",
];

const RevenuesAndExpensive = (props) => {
  const [data, setData] = useState({
    cashFlowYear: [],
    cashFlowMonth: [],
    clientTopTen: [],
    sumCategory: [],
    categoryTopTen: [],
  });
  const [loading, setLoading] = useState(false);
  const [dataQuarter, setDataQuarter] = useState(false);
  const [filterStartDate, setStartDate] = useState(moment().format(dateFormat));
  const [filterEndDate, setEndDate] = useState(moment().format(dateFormat));
  const [dataIncome, setDataIncome] = useState([]);
  const [loadingIncome, setLoadingIcome] = useState(false);
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterBanks, setFilterBanks] = useState([]);

  useEffect(() => {
    getData();

    getStatus().then((res) => {
      let resIdStatus = res.map((item) => item.name);
      setFilterStatus(resIdStatus);
      getBanks().then((res) => {
        let resIdBank = res.map((item) => item.codeAccount);
        setFilterBanks(resIdBank);
        getMappingDataIncome(resIdStatus, resIdBank);
      });
    });
  }, [props]);

  function getData() {
    setLoading(true);
    if (filterEndDate == null || filterEndDate == null) {
      notificationInfo("É nescesário informar o mês inicial e final.");

      setLoadingIcome(false);
      setLoading(false);
      return;
    }

    const filter = {
      type: props.type,
      start: filterStartDate,
      end: filterEndDate,
    };
    getCashFlowByTypeToDashboard(filter)
      .then((res) => {
        let cashFlowQuarter = [];
        var index = 1;
        var sum = 0;
        var quarter = 1;
        let monthOrder = [];
        monthOrder.push(...res.cashFlowMonth);
        monthOrder.push({ amount: 0 });
        monthOrder.forEach((m) => {
          let amount = m.amount;
          if (index <= 3) {
            sum = sum + amount;
            index++;
          } else {
            cashFlowQuarter.push({
              datetrunc: "Q" + quarter,
              amount: sum.toFixed(2),
            });
            sum = m.amount;
            quarter++;
            index = 2;
          }
        });
        setDataQuarter(cashFlowQuarter);
        setData(res);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function getMappingDataIncome(filterStatus, filterBanks) {
    setLoadingIcome(true);
    if (filterEndDate == null || filterEndDate == null) {
      setLoadingIcome(false);
      setLoading(false);
      return;
    }

    const filter = {
      start: filterStartDate,
      end: filterEndDate,
      status: filterStatus,
      banks: filterBanks,
      type: "COMPETENCE",
    };
    getIncomeV2(filter)
      .then((res) => {
        let dataIncome = res.filter((f) => f.is_total == true);

        dataIncome = dataIncome.sort(
          (a, b) => a.order_mapping - b.order_mapping
        );
        setDataIncome(dataIncome);
        setLoadingIcome(false);
      })
      .catch((err) => {
        setLoadingIcome(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function showConfirm(title, div, icon) {
    info({
      title: (
        <span style={{ fontFamily: font }}>
          {icon}
          {title}
        </span>
      ),
      icon: null,
      content: div,
      width: "90%",
      centered: true,
      getContainer() {},
      onOk() {},
    });
  }

  const setFilterStartDateRange = (e) => {
    if (e == null) {
      setStartDate(null);
      setEndDate(null);
    } else {
      setStartDate(e[0].format(dateFormat));
      setEndDate(e[1].format(dateFormat));
    }
  };

  const setFilterStartDate = (e) => {
    if (e == null) {
      setStartDate(moment().format(dateFormat));
    } else {
      setStartDate(e.format(dateFormat));
    }
  };
  const setFilterEndDate = (e) => {
    if (e == null) {
      setEndDate(moment().format(dateFormat));
    } else {
      setEndDate(e.format(dateFormat));
    }
  };
  const refreshData = () => {
    getData();
    getMappingDataIncome(filterStatus, filterBanks);
  };
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontFamily: font,
          }}
        >
          <p className="intro">{`${label}`}</p>

          <p className="intro">
            {props.type == "CONTA_A_RECEBER" ? "Receita" : "Despesa"}:{" "}
            <span
              style={{
                color:
                  props.type == "CONTA_A_RECEBER" ? receiveColor : padColor,
              }}
            >
              {formatCurrency(payload[0].value)}
            </span>
          </p>
        </div>
      );
    }

    return null;
  };

  const CustomTooltipYearComparetion = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontFamily: font,
          }}
        >
          <p className="intro">{`${label}`}</p>
          <p className="intro">
            Ano Atual:{" "}
            <span style={{ color: receiveColor }}>
              {formatCurrency(payload[0].value)}
            </span>
          </p>
          <p className="intro">
            Ano Anterior:{" "}
            <span style={{ color: padColor }}>
              {formatCurrency(payload[1].value)}
            </span>
          </p>
        </div>
      );
    }

    return null;
  };

  const chartYear = () => {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          data={data.cashFlowYear}
          margin={{
            top: 5,
            right: 30,
            left: 40,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="datetrunc" />
          <YAxis tickFormatter={(value) => formatCurrency(value)} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="amount" fill={receiveColor} />
        </BarChart>
      </ResponsiveContainer>
    );
  };
  const chartQuater = () => {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          data={dataQuarter}
          margin={{
            top: 5,
            right: 30,
            left: 40,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="datetrunc" />
          <YAxis tickFormatter={(value) => formatCurrency(value)} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="amount" fill={profitColor} />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const chartMonth = () => {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <AreaChart
          width={500}
          height={400}
          data={data.cashFlowMonth}
          margin={{
            top: 10,
            right: 30,
            left: 40,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="monthData" />
          <YAxis tickFormatter={(value) => formatCurrency(value)} />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="amount"
            stroke="#00887B"
            fill="#09AC9C"
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  };
  const chartYearComparation = () => {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          data={data.cashFlowMonth}
          margin={{
            top: 5,
            right: 30,
            left: 40,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="monthData" />
          <YAxis tickFormatter={(value) => formatCurrency(value)} />
          <Tooltip content={<CustomTooltipYearComparetion />} />
          <Bar dataKey="amount" fill={receiveColor} />
          <Bar
            dataKey={data.showBudget ? "budget" : "monthLast"}
            fill={padColor}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };
  const CustomTooltipPie = ({ active, payload }) => {
    if (active && payload && payload.length) {
      console.log(payload[0]);
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
          }}
        >
          <p>{`${payload[0].name}:   ${formatCurrency(payload[0].value)}`}</p>
        </div>
      );
    }

    return null;
  };
  const CustomLegend = ({ payload }) => (
    <ul
      style={{
        listStyleType: "none",
        padding: 0,
        overflowX: "auto",
        height: 100,
      }}
    >
      {payload.map((entry, index) => (
        <li
          key={`item-${index}`}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              backgroundColor: entry.color,
              marginRight: 8,
              borderRadius: 20,
            }}
          ></span>
          <Text style={{ fontFamily: font }}>{entry.value}</Text>
          <Text
            style={{ marginLeft: "auto", fontFamily: font, color: "#9FA1AA" }}
          >
            {formatCurrency(entry.payload.value)}
          </Text>
        </li>
      ))}
    </ul>
  );

  const chartCategories = () => {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            labelLine={false}
            data={data.categoryTopTen}
            dataKey="amount"
            nameKey="category"
            label={({ name, value, percent }) =>
              `${(percent * 100).toFixed(2).replace(".", ",")}%`
            }
          >
            {data.categoryTopTen?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltipPie />} />
          <Legend content={<CustomLegend />} />
        </PieChart>
      </ResponsiveContainer>
    );
  };

  const DREDonutChart = () => (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Pie
          data={dataIncome}
          dataKey="total"
          nameKey="grupo"
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          fill="#8884d8"
          paddingAngle={5}
        >
          {dataIncome?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltipPie />} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );

  const chartClients = () => (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart
        layout="vertical"
        width={500}
        height={400}
        data={data.clientTopTen}
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis type="number" tickFormatter={(value) => formatCurrency(value)} />
        <YAxis
          type="category"
          dataKey="customer"
          tickFormatter={(value) => value.substring(0, 8)}
        />{" "}
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="amount" fill={receiveColor}>
          <LabelList
            dataKey="amount"
            position="insideRight"
            formatter={(value) => formatCurrency(value)}
            fill="#ffffff"
          />
          {data.clientTopTen?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </ComposedChart>
    </ResponsiveContainer>
  );
  return (
    <div className="revenues">
      <Spin size="large" spinning={loading}>
        <Space>
          <RangePicker
            defaultValue={[
              dayjs(filterStartDate, dateFormat),
              dayjs(filterEndDate, dateFormat),
            ]}
            placeholder={["Mês Inicial", "Mês Final"]}
            format={dateFormat}
            picker="month"
            suffixIcon={<CalendarDays size={18} />}
            onChange={setFilterStartDateRange}
          />

          <Button
            style={{ fontFamily: font }}
            type="primary"
            icon={
              <ArrowRight
                size={18}
                style={{ marginBottom: "-3px", marginRight: "7px" }}
              />
            }
            onClick={refreshData}
          >
            Filtrar
          </Button>
        </Space>
        <Row gutter={[24, 24]} style={{ marginTop: "15px", marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "33%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <CalendarDays
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "14px", fontFamily: font }}>
                      {props.type == 'CONTA_A_RECEBER'? 'Faturamento Anual':'Despesa Anual'}

                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                       (props.type == 'CONTA_A_RECEBER'? 'Faturamento Anual':'Despesa Anual'),
                        chartYear(),
                        <CalendarDays
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              style={{ width: "100%" }}
            >
              {" "}
              {chartYear()}
            </Card>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "33%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Landmark
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      {props.type == 'CONTA_A_RECEBER'? 'Faturamento Mensal':'Despesa Mensal'}

                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        (props.type == 'CONTA_A_RECEBER'? 'Faturamento Mensal':'Despesa Mensal'),
                        chartMonth(),
                        <Landmark
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              bordered={false}
            >
              {chartMonth()}
            </Card>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "33%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <CalendarClock
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      {props.type == 'CONTA_A_RECEBER'? 'Faturamento  por trimestr':'Despesa  por trimestre'}

                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        (props.type == 'CONTA_A_RECEBER'? 'Faturamento  por trimestr':'Despesa  por trimestre'),

                        chartQuater(),
                        <CalendarClock
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              bordered={false}
            >
              {chartQuater()}
            </Card>
          </Space>
        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: "15px", marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "66%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <FileInput
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "14px", fontFamily: font }}>
                      Realizado x {data.showBudget ? "Orçado" : "Ano Anterior"}
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Realizado x " +
                          (data.showBudget ? "Orçado" : "Ano Anterior"),
                        chartYearComparation(),
                        <FileInput
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              style={{ width: "100%" }}
            >
              {" "}
              {chartYearComparation()}
            </Card>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "33%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <MoveUpRight
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Top 10 Categorias e Composição
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Top 10 Categorias e Composição",
                        chartCategories(),
                        <MoveUpRight
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              bordered={false}
            >
              {chartCategories()}
            </Card>
          </Space>
        </Row>
        <Row gutter={[24, 24]} style={{ marginTop: "15px", marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "50%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <MoveUpRight
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "14px", fontFamily: font }}>
                      Top 10 Clientes
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Top 10 Clientes",
                        chartClients(),
                        <MoveUpRight
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              style={{ width: "100%" }}
            >
              {" "}
              {chartClients()}
            </Card>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "50%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <GitMerge
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Funil de Grupos
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Funil de Grupos",
                        DREDonutChart(),
                        <GitMerge
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              bordered={false}
            >
              {DREDonutChart()}
            </Card>
          </Space>
        </Row>
      </Spin>
    </div>
  );
};
export default RevenuesAndExpensive;
